<template>
    <div style="padding-bottom: 40px">
        <M3Warn v-if="data && data.m3_project && data.m3_project.duplicate_sections && data.m3_project.duplicate_sections.includes('financial_request')" type="yellow" :text="'Această secțiune a fost duplicată din proiectul companiei ' + getCompanyName(data.m3_project.duplicate_company_id)"></M3Warn>
        <CFTitle title="11. Sustenabilitate"></CFTitle>
        <M3Warn type="yellow" text="Se va preciza modul în care se va autosusține financiar după încetarea finanțării solicitate prin prezenta cerere:
                                        <ul>
                                            <li>Ce acțiuni/activități vor trebui realizate și/sau continuate după finalizarea proiectului</li>
                                            <li>Cum vor fi realizate aceste acțiuni/activități și ce resurse vor fi necesare</li>
                                            <li>Nivelul/Statutul de protecție vizat conform legislației  naționale cu privire la ... (dacă este relevant)</li>
                                            <li>Cum, unde și de cine va fi utilizat echipamentul/locația/etc. după finalizarea proiectului</li>
                                            <li>Alte aspecte relevante</li>
                                        </ul>"
        ></M3Warn>
        <validation-observer #default="{ invalid }" ref="responsabilProiect">
            <span class="display-none">{{ invalid }}</span>
            <div>
                <p class="subtitle">Descrierea/Valorificarea rezultatelor:</p>
                <validation-provider
                    #default="{ errors }"
                    rules="required"
                >
                    <CFTextarea v-model="form.descriere" :read-only="completed" :limit="3500"></CFTextarea>
                    <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
            </div>
            <div style="margin-top: 20px">
                <p class="subtitle">Furnizați informații cu privire la toate acordurile instituționale relevante încheiate cu terțe părți pentru implementarea proiectului si exploatarea cu succes a investițiilor care au fost planificate si eventual încheiate, după caz</p>
                <validation-provider
                    #default="{ errors }"
                    rules="required"
                >
                    <CFTextarea v-model="form.acorduri" :read-only="completed" :limit="1750"></CFTextarea>
                    <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
            </div>
            <div style="margin-top: 20px">
                <p class="subtitle">Oferiți detalii cu privire la modul in care va fi gestionata investiția după încheierea proiectului (si anume, numele operatorului; metode de selecție - administrare publica sau concesiune; tip de contract etc.</p>
                <validation-provider
                    #default="{ errors }"
                    rules="required"
                >
                    <CFTextarea v-model="form.gestionare" :read-only="completed" :limit="1750"></CFTextarea>
                    <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
            </div>
        </validation-observer>
        <b-form-checkbox
            v-model="completed"
            switch
            size="lg"
            class="switch-box"
            style="margin-bottom: -40px;"
            @change="sendForm()"
        >Informațiile sunt complete și corecte</b-form-checkbox>
    </div>
</template>

<script>
    import CFTitle from "./CFTitle";
    import CFTextarea from "./CFTextarea";
    import { BFormCheckbox } from "bootstrap-vue";
    import M3Warn from "../M3Warn";
    import api from '@/helpers/api';
    import axios from '@/helpers/axios';
    import { ValidationProvider, ValidationObserver } from 'vee-validate';
    import _ from "lodash";

    export default {
        name: "CFSustenabilitate",
        components: {
            CFTextarea,
            BFormCheckbox,
            CFTitle,
            M3Warn,
            ValidationProvider,
            ValidationObserver,
        },
        props:{
            m3GrantApplication: {
                type: Object,
                default: null
            },
            indicators: {
                type: Object,
                default: null
            },
            termeneV3: {
                type: Object,
                default: null
            },
            data: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                form: {
                    descriere: '',
                    acorduri: '',
                    gestionare: ''
                },
                completed: null,
            }
        },
        computed: {
            companies() {
                return this.$store.getters['m3Sketch/companies'];
            },
            finantareProgress() {
                return this.$store.getters['finantare/progress']
            }
        },
        watch: {
            finantareProgress: {
                handler: function() {
                    if(this.finantareProgress && this.finantareProgress.includes('Sustenabilitate')) {
                        this.completed = true
                    }
                },
                deep: true
            },
            m3GrantApplication: {
                handler () {
                    if(this.m3GrantApplication && this.m3GrantApplication.sustenabilitate){
                        this.form.acorduri = this.m3GrantApplication.sustenabilitate.acorduri;
                        this.form.descriere = this.m3GrantApplication.sustenabilitate.descriere;
                        this.form.gestionare = this.m3GrantApplication.sustenabilitate.gestionare;
                    }
                },
                deep: true
            }
        },
        mounted() {
            if(this.m3GrantApplication && this.m3GrantApplication.sustenabilitate){
                this.form.acorduri = this.m3GrantApplication.sustenabilitate.acorduri;
                this.form.descriere = this.m3GrantApplication.sustenabilitate.descriere;
                this.form.gestionare = this.m3GrantApplication.sustenabilitate.gestionare;
            } else {
                let bilant2019 = _.filter(this.termeneV3.bilant_scurt, v => v.an === 2019);
                let angajati2019 = 0;
                if(this.data && this.data.m3_project && this.data.m3_project.indicators && this.data.m3_project.indicators.indicators && this.data.m3_project.indicators.indicators.employees && this.data.m3_project.indicators.indicators.employees.number2019) {
                    angajati2019 = this.data.m3_project.indicators.indicators.employees.number2019
                } else {
                    angajati2019 = bilant2019[0] && bilant2019[0].numar_mediu_angajati ? bilant2019[0].numar_mediu_angajati : 1
                }
                let locuriMunca = this.data && this.data.m3_project && this.data.m3_project.indicators && this.data.m3_project.indicators.indicators && this.data.m3_project.indicators.indicators.employees ? this.data.m3_project.indicators.indicators.employees.number : 0;

                this.form.descriere = 'Solicitantul va asigura în mod asumat sustenabilitatea activităților vizate prin proiect prin creșterea productivității muncii și a numărului de angajați de la '+ angajati2019 +' la '+ Number(locuriMunca) +'. În cadrul Rapoartelor de Durabilitate, vor fi prevăzute toate informațiile privind modul și locul de utilizare a infrastructurilor, echipamentelor și bunurilor realizate sau achiziționate în cadrul proiectului, modul în care investiția în infrastructură sau investiția productivă continuă să genereze rezultate, îndeplinirea indicatorilor de rezultat în conformitate cu angajamentele asumate prin contractul de finanțare. \n' +
                    '\n' +
                    ''+ JSON.parse(localStorage.getItem('currentM3Company')).name +' își asumă faptul că în cursul celor 3 ani de sustenabilitate nu se va produce nicio schimbare substanțială care să afecteze natura, obiectivele sau condiţiile de realizare și care ar determina subminarea obiectivelor inițiale ale acestora, schimbare asupra  proprietăţii unui element de infrastructură care conferă un avantaj nejustificat unei întreprinderi sau unui organism public, încetarea sau delocalizarea unei activități productive în afara zonei eligibile. \n' +
                    '\n' +
                    'Introduceti detalii despre  Descrierea/Valorificarea rezultatelor:\n'
                this.form.acorduri = 'Vă rugăm detaliați'
                this.form.gestionare = 'Vă rugăm detaliați'
            }

            if(this.finantareProgress && this.finantareProgress.includes('Sustenabilitate')) {
                this.completed = true
            }
        },
        methods: {
            getCompanyName(id){
                let name = '';
                this.companies.forEach(company => {
                    if(Number(company.id) === Number(id))
                        name = company.name
                })

                return name;
            },
            sendForm(){
                if(this.completed){
                    this.$refs.responsabilProiect.validate().then((e) => {
                        if (!e) {
                            this.completed = false
                            this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                        } else {
                            axios.post(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/grant-application',  {sustenabilitate: this.form})
                                .then( () => {
                                    this.$toast.success('Informațiile au fost salvate!')
                                    this.$store.dispatch('finantare/addToProgress', 'Sustenabilitate')
                                    this.$emit('savedData')
                                })
                        }
                    })
                }
                else{
                    this.$store.dispatch('finantare/removeFromProgress', 'Sustenabilitate')
                }
            }
        }
    }
</script>

<style scoped>
    .subtitle{
        font-weight: bold;
    }
</style>
